module.exports = __webpack_public_path__ + "static/media/icon-03.cf85cd81.png";